const fintec = [
  { label: 'Ja, Kontoblick durchführen', value: true },
  { label: 'Nein, ohne Kontoblick fortfahren', value: false }
]

export default fintec
